import { makeStyles } from 'tss-react/mui';
export var seniorWellnessInfoStyle = makeStyles()(function (theme) {
    var _a, _b;
    return ({
        seniorWellnessInfoContainer: (_a = {
                backgroundColor: theme.palette.customColor.white,
                borderRadius: 16,
                width: '100%',
                // height: 152,
                padding: 25,
                boxShadow: '0 8px 24px 0 rgba(0, 0, 0, 0.16)'
            },
            _a[theme.breakpoints.down('sm')] = {
                '.MuiGrid-item': {
                    flexWrap: 'wrap'
                }
            },
            _a),
        detailContainer: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
            marginBottom: 15,
        },
        detailLableContainer: {
            display: 'flex',
            alignItems: 'center',
            minWidth: '220px'
        },
        detailValueContainer: {},
        selectWidth: {
            width: '100%',
        },
        detailValues: (_b = {
                fontSize: 16,
                position: 'relative',
                paddingLeft: '12px',
                '&:before': {
                    position: 'absolute',
                    content: '":"',
                    left: '0',
                    top: '50%',
                    transform: 'translateY(-50%)',
                }
            },
            _b[theme.breakpoints.down('xl')] = {
                fontSize: 14,
            },
            _b[theme.breakpoints.down('sm')] = {
                paddingLeft: '0px',
                '&:before': {
                    display: 'none',
                }
            },
            _b),
        inputLabel: {
            fontWeight: 'bold',
            whiteSpace: 'nowrap',
            alignSelf: 'center',
            minWidth: '190px'
        }
    });
});
